import { SET_DEVELOPER_MODE } from "./action-types";

// eslint-disable-next-line import/prefer-default-export
export function setDeveloperMode(isEnabled: boolean) {
  return {
    type: SET_DEVELOPER_MODE,
    payload: { isEnabled },
  };
}
